module.exports = __webpack_public_path__ + "img/kantine_2.238294c0.jpg";